import React, { useMemo } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { useTranslation } from 'react-i18next'

import ContentBlock from 'components/ContentBlock'
import { Form, Text, Number as NumberField, Select } from 'components/forms'
import Button from 'components/Button'
import Divider from 'components/Divider'
import { loadAppConstants } from 'gql/query'
import { notEmpty } from 'helpers/validators'

const MWStEnums = ['normal', 'reduced', 'free', 'special']

const CashBook = ({ customData, newRecord, mutations }) => {
	const [t, i18n] = useTranslation()

	const taxRemoteOptions = useMemo(() => ({
		query: loadAppConstants,
		variables: { type: 33, language: i18n.language },
		modifyOptions: options => options.map(item => ({ ...item, value: MWStEnums[item.value - 1] }))
	}), [])

	const handleSubmit = vals => {
		if(newRecord) {
			mutations.createItem(vals)
		} else {
			mutations.updateItem(vals)
		}
	}

	return(
		<ContentBlock>
			<Form initialValues={ newRecord ? {} : customData || {}} onSubmit={handleSubmit} smartSubmit={!newRecord}>
				<Row>
					<Col xs>
						<Text
							field='description'
							label={t('options_section.fields.description')}
							{...notEmpty()}
							validateOnChange
						/>
						<Text
							field='shouldAccount'
							label={t('options_section.fields.owe_account')}
							shrink
							inline
							{...notEmpty()}
							validateOnChange
						/>
						<Text
							field='haveAccount'
							label={t('options_section.fields.own_account')}
							shrink
							inline
							{...notEmpty()}
							validateOnChange
						/>
					</Col>
					<Col xs>
						<Select
							field='tax'
							remoteOptions={taxRemoteOptions}
							label={t('options_section.fields.tax')}
							shrink
							inline
							{...notEmpty()}
							validateOnChange
						/>
						<NumberField
							field='taxAmount'
							label={t('options_section.fields.tax_amount')}
							shrink
							withControls={false}
							inline
						/>
						<Select
							field='type'
							options={[
								{ value: 'income', label: t('options_section.strings.income') },
								{ value: 'outcome', label: t('options_section.strings.outcome') }
							]}
							label={t('common.fields.type')}
							{...notEmpty()}
							validateOnChange
						/>
					</Col>
				</Row>
				{newRecord &&
					<>
						<Divider />
						<Button type='submit' status='primary' text={t('common.buttons.create')} />
					</>
				}
			</Form>
		</ContentBlock>
	)
}

export default CashBook
